<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table
      ref="dataTable"
      :data="lists"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      class="mt-30"
      height="600"
      :summary-method="getSummaries"
      show-summary
    >
      <!-- 只用一个 el-table-column + v-for 搞定所有 -->
      <el-table-column
        v-for="(col, index) in tableColumns"
        :key="`${col.columnName}-${index}`"
        :prop="col.columnName"
        :label="col.columnTitle"
        align="center"
        v-if="col.isShow"
      >
        <!-- 表头双击打开设置 -->
        <template slot="header" slot-scope="scope">
          <span @dblclick="isShowColumn = true">
            <i
              v-if="index === 0"
              class="el-icon-setting"
              style="cursor:pointer;margin-right:6px"
              @click="isShowColumn = true"
            ></i>
            {{ col.columnTitle }}
          </span>
        </template>

        <!-- 内容区域：根据 columnName 自动匹配 -->
        <template slot-scope="scope">
          <!-- 广告 -->
          <div v-if="col.columnName === 'adid'">
            {{ scope.row.title }}({{ scope.row.adid }})
          </div>

          <!-- 报单下载 -->
          <el-button
            v-else-if="col.columnName === 'download1'"
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="download(scope.$index, 1)"
          />

          <!-- 截图下载 -->
          <div v-else-if="col.columnName === 'download2'">
            <el-button v-if="scope.row.presale == 0" type="primary" icon="el-icon-download" size="mini" @click="download(scope.$index, 2)" />
            <el-button v-else type="primary" icon="el-icon-download" size="mini" @click="download(scope.$index, 5)" />
          </div>

          <!-- 上家/底价 -->
          <div v-else-if="col.columnName === 'aver_discount'">
            {{ scope.row.aver_discount }}% / {{ scope.row.min_discount }}%
          </div>

          <!-- 报单数 -->
          <div v-else-if="col.columnName === 'upload_ocount'">
            {{ scope.row.upload_ocount + scope.row.presale_ocount }}
          </div>

          <!-- 报单金额 -->
          <div v-else-if="col.columnName === 'upload_payment'">
            {{ scope.row.upload_payment + scope.row.presale_payment }}
          </div>

          <!-- 其他所有字段自动显示 -->
          <span v-else>
            {{ scope.row[col.columnName] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, pager, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="filters.l"
      :page-sizes="[20, 50, 80, 100]"
      :total="filters.total"
      :current-page="filters.p"
      class="tac mt-36 pb-36"
    />

    <!-- 完全沿用你前面蓝本的列设置组件 -->
    <TableColumnSetting
      :visible.sync="isShowColumn"
      :column-list.sync="tableColumns"
      :default-columns="defaultColumns"
      :storage-key="`${$options.name}_table_columns`"
    />
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {adDayBase, adPeriodDayBase, downloadAdOrderLists} from '../../../api/api'
import adSelect from '../../../components/data-select/adSelect.vue'

export default {
  name: 'adDayBase',
  mixins: [mixinList],
  components: {
    adSelect
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      isShowColumn: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        title: ''
      },
      adLists: [],
      // 和页面原列顺序完全一致
      defaultColumns: [
        { columnName: 'date', columnTitle: '日期', isShow: true, isSum: false },
        { columnName: 'adid', columnTitle: '广告', isShow: true, isSum: false },
        { columnName: 'oper_nickname', columnTitle: '负责人', isShow: true, isSum: false },
        { columnName: 'aver_name', columnTitle: '上家', isShow: true, isSum: false },
        { columnName: 'download1', columnTitle: '报单下载', isShow: true, isSum: false },
        { columnName: 'download2', columnTitle: '截图下载', isShow: true, isSum: false },
        { columnName: 'aver_discount', columnTitle: '上家/底价', isShow: true, isSum: false },

        { columnName: 'ocount', columnTitle: '有效订单数', isShow: true, isSum: true },
        { columnName: 'payment', columnTitle: '有效金额', isShow: true, isSum: true },
        { columnName: 'upload_ocount', columnTitle: '报单数', isShow: true, isSum: true },
        { columnName: 'upload_payment', columnTitle: '报单金额', isShow: true, isSum: true },
        { columnName: 'upload_commission', columnTitle: '报单佣金', isShow: true, isSum: true },
        { columnName: 'invalid_ocount', columnTitle: '丢单订单数', isShow: true, isSum: true },
        { columnName: 'invalid_payment', columnTitle: '丢单金额', isShow: true, isSum: true },
        { columnName: 'apply_ocount', columnTitle: '可提现订单数', isShow: true, isSum: true },
        { columnName: 'apply_commission', columnTitle: '可提现金额', isShow: true, isSum: true },
        { columnName: 'exchange_commission', columnTitle: '打款金额', isShow: true, isSum: true }
      ],
      tableColumns: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    getSummaries (param) {
      return util.getSummaries(param, this.defaultColumns)
    },
    download (index, choose) {
      const startTime = new Date(this.lists[index].date)
      startTime.setHours(0, 0, 0, 0)
      const startTs = Math.floor(startTime.getTime() / 1000)
      let link = downloadAdOrderLists + '?external=1&choose=' + choose
      link = link + '&adid=' + this.lists[index]['adid']
      link = link + '&start_time=' + startTs
      link = link + '&end_time=' + startTs
      link = link + '&field=' + 'date,orderid,payment'
      if (this.lists[index]['extra']) {
        link = link + ',extra'
      }
      window.open(link, 'a')
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      this.listLoading = true
      if (filters.title !== '') {
        params.title = filters.title
      }
      let condition = true
      if (filters.adid !== '') {
        params.adid = filters.adid
        condition = false
      }
      (condition ? adDayBase : adPeriodDayBase)(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    // 蓝本同款初始化
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'getList',
    'filters.title': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adDayBase.vue